module.exports = __webpack_public_path__ + "static/media/accessory__gasSensor.37145a8b.jpg";